import React from 'react';

import * as flags from '../CountrySelect/config';

import './countryflagrounded.css';


const CountryFlagRounded=({countryData=[]})=>{

  if(countryData.length < 2) {
    const countryProp = countryData[0].replace(/ /g, '_');
    const countryFlag = flags[countryProp];
    countryData[1]=countryFlag;
  }
  
  
  const [name,flag]=countryData;
  // console.log('CountryFlagRounded',countryData);
  // <img src={flag} alt={name} />

  return (
    <div className="country-flag-rounded" style={{backgroundImage:`url(${flag})`}}></div>
  )
}

export default CountryFlagRounded;